<select #comboBox [(ngModel)]="selectedCodeValue" [disabled]="disabled" [hidden]="!visible" [autofocus]="autofocus"
  (change)="onChange($any($event.target).value);" (blur)="onTouched()" [style.width.px]="width"
  [style.width]="width??'100%'" [style.height.px]="height" [style.height]="height??'100%'"
  [class.combo-box-required]="required" [tabindex]="tabindex">
  <option *ngIf="blank" value="blankVal"></option>
  <ng-template ngFor let-item [ngForOf]="listSource">
    <option *ngIf="!dspBothField" [value]="item[valueField]">{{item[labelField]}}</option>
    <option *ngIf="dspBothField" [value]="item[valueField]">{{item[valueField]}}&#058;{{item[labelField]}}</option>
  </ng-template>
</select>